import {Component} from '@angular/core';
import {BannersHttpService} from '../../../services/http-services/banners/banners-http.service';
import {GrBanner} from '../../../interfaces/banners-interfaces';
import {ToastrService} from 'ngx-toastr';
import {BannerTypeEnum} from '../../../enums/banner-enums';

@Component({
  selector: 'gr-banners',
  templateUrl: './banners.component.html',
})
export class BannersComponent {
  bannerForDelete: GrBanner | null = null;
  bannerForEdit: GrBanner | null = null;
  isCreateBannerModalOpen = false;
  activeTab = BannerTypeEnum.application;
  isBannerChange = false;
  protected readonly BannerTypeEnum = BannerTypeEnum;

  constructor(private bannersHttpService: BannersHttpService,
              private toastService: ToastrService) {
  }

  onConfirmCreateOrEditBanner(): void {
    this.bannerForEdit = null;
    this.isCreateBannerModalOpen = false;
    this.isBannerChange = true;
    setTimeout(() => {
      this.isBannerChange = false;
    }, 1000);
  }

  onConfirmDeleteBanner(): void {
    this.bannersHttpService.deleteBanner({bannerId: this.bannerForDelete?.id}, this.activeTab === BannerTypeEnum.landing).then((res: any) => {
      this.bannerForDelete = null;
      this.isBannerChange = true;
      setTimeout(() => {
        this.isBannerChange = false;
      }, 1000);
      this.toastService.success('Usepšeno ste obrisali banner.');
    }).catch(({error}: {error: { errors: { [key: string]: string } }}) => {
      Object.values(error.errors).forEach(error => this.toastService.error(error));
    });
  }
}
